export enum NotificationRecordStatus {
    Unknown,
    Pending,
    Sent,
    Delivered,
    Read,
    Failed,
    OverQuota,
}
